import { render, staticRenderFns } from "./Quizset.vue?vue&type=template&id=059b6d5a&"
import script from "./Quizset.vue?vue&type=script&lang=js&"
export * from "./Quizset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports